/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Password_ReusedInputs */

const cs_auth_reset_password_reused = /** @type {(inputs: Auth_Reset_Password_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvolte heslo, které jste ještě nepoužili.`)
};

const en_auth_reset_password_reused = /** @type {(inputs: Auth_Reset_Password_ReusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a password you have not used before.`)
};

/**
* | output |
* | --- |
* | "Choose a password you have not used before." |
*
* @param {Auth_Reset_Password_ReusedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_password_reused = /** @type {((inputs?: Auth_Reset_Password_ReusedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Password_ReusedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_password_reused(inputs)
	return cs_auth_reset_password_reused(inputs)
});